import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import image1 from "../../../assets/images/Project/1-rasm.jpg";
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../../config';

const Connect = () => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <section className="section" id="wallet">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6}>
                            <div className="text-center">
                                <img src={image1} alt="" className="img-fluid shadow-lg"/>
                            </div>
                        </Col>
                        <Col lg={6} className='ps-1 ps-lg-4'>
                            <div className="text-start mb-5">
                                <h2 className="mb-3 lh-base text-capitalize">
                                    {t('t-fact-details')}
                                </h2>
                                <p className="text-muted">
                                    {t('t-fact-details-desc').replace('{appName}', appConfig.appName)}
                                </p>
                                <div className="vstack gap-2">
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">{t('t-fact-details1')}</p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-fact-details2')}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-fact-details3')}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-fact-details4')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Connect;